/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import moment from 'moment';
import Linkify from 'react-linkify';

import Localized from '../../../../shared/components/Localized';
import FooterTimeStamp from '../../FooterTimestamp';

import { Wrapper, TitleWrapper, Title, Body} from './styles.js';

const Event = ({ feedItem, region, missingTranslations }) => (
  <Linkify properties={{ target: '_blank' }}>
    <Wrapper severity={feedItem.severity}>
      <TitleWrapper>
        <div>
          <Title>
            <Localized
              modelName='incidentEventType'
              modelKey={feedItem.event.type}
              modelAttribute='label'
              missingTranslations={missingTranslations}
            />
            <span></span>
          </Title>
        </div>
      </TitleWrapper>
      <Body>
        <span>{ feedItem.event.message }</span>
      </Body>
      <FooterTimeStamp 
        createdTime= {feedItem.dateTime}
        lastModifiedTime={feedItem.updateTime}
        region= {region} 
        missingTranslations={missingTranslations}
      />
    </Wrapper>
  </Linkify>
);

export default Event;
